var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read"},[_c('div',{staticClass:"subject"},[_vm._v(_vm._s(_vm.data.messageSubject))]),_c('div',{staticClass:"text body",domProps:{"innerHTML":_vm._s(_vm.data.messageContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }